module.exports = __webpack_public_path__ + "img/wps_plus_logo.9f1231ad.svg";